class Common {
    constructor() {
        this.selectStyles = () => {
            return {
                option: (base, state) => (Object.assign({}, base, { backgroundColor: state.isFocused ? 'rgba(255, 255, 255, 0.1)' : 'none', borderBottom: '1px solid black', color: 'white', padding: 15, '&:hover': {
                        backgroundColor: 'rgba(255, 255, 255, 0.1)'
                    }, '.Select-option.is-selected': {
                        backgroundColor: 'none'
                    }, '&:active': {
                        backgroundColor: 'rgba(0, 0, 0, 1)'
                    } })),
                menu: (base) => (Object.assign({}, base, { backgroundColor: 'rgba(0, 0, 0, 0.9)', backgroundImage: 'none', border: '0px none' })),
                control: (base) => (Object.assign({}, base, { backgroundColor: 'rgba(0, 0, 0, 0.9)', backgroundImage: 'none', border: '0px none', margin: '0;', minWidth: '300px' })),
                valueContainer: (base) => (Object.assign({}, base, { backgroundColor: 'rgba(0, 0, 0, 0.9)', backgroundImage: 'none', border: '0px none' })),
                multiValue: (base) => (Object.assign({}, base, { backgroundColor: 'rgba(255, 255, 255, 0.3)' })),
                multiValueLabel: (base) => (Object.assign({}, base, { color: '#fff' })),
                singleValue: (base) => (Object.assign({}, base, { color: '#fff' })),
                input: (base) => (Object.assign({}, base, { color: '#fff' }))
            };
        };
        this.savedLists = () => {
            let lists = {};
            const listCache = localStorage.getItem('lists');
            if (listCache) {
                lists = JSON.parse(listCache);
            }
            return lists;
        };
        this.listsForSelect = () => {
            const lists = this.savedLists();
            let listNames = [];
            if (lists) {
                listNames = Object.keys(lists);
            }
            return listNames.map((name) => {
                return {
                    value: name,
                    label: name
                };
            });
        };
        this.updateListCache = (listId) => {
            let lists = {};
            const listCache = localStorage.getItem('lists');
            if (listCache) {
                lists = JSON.parse(listCache);
            }
            if (listId && /^\w/.test(listId)) {
                lists[listId] = true;
                localStorage.setItem('lists', JSON.stringify(lists));
            }
        };
    }
}
export default Common;
//# sourceMappingURL=common.js.map


// WEBPACK FOOTER //
// ./src/util/common.js